export default __webpack_public_path__ + "static/media/Jabalpur.b3e282df.jpg";